export const REACT_APP_DEPLOY_ENV = window.REACT_APP_DEPLOY_ENV;
export const REACT_APP_MAIN_SITE_HOMEPAGE = window.REACT_APP_MAIN_SITE_HOMEPAGE;
export const REACT_APP_API_URL = window.REACT_APP_API_URL;
export const REACT_APP_ZONE_RESERVEE_RECHARGE_URL =
  window.REACT_APP_ZONE_RESERVEE_RECHARGE_URL;
export const PUBLIC_URL = window.PUBLIC_URL;
export const REACT_APP_REDIRECT_REG = window.REACT_APP_REDIRECT_REG;
export const REACT_APP_REDIRECT_SSO = window.REACT_APP_REDIRECT_SSO;
export const REACT_APP_KEY_RE_CAPTCHA = window.REACT_APP_KEY_RE_CAPTCHA;
export const REACT_APP_UTAG_URL = window.REACT_APP_UTAG_URL;
export const REACT_APP_UTAG_SYNC_URL = window.REACT_APP_UTAG_SYNC_URL;
export const REACT_APP_VIVOCHAT_SRC_URL = window.REACT_APP_VIVOCHAT_SRC_URL;
export const REACT_APP_ONE_TRUST = window.REACT_APP_ONE_TRUST;
